export default __webpack_public_path__ + "static/media/Calendar-&-Appointment.606e3808.svg";